export enum CampaignEditorErrorsActions {
    SAVE_ERRORS = 'campaignEditorErrors/SAVE_ERRORS',
    RESET_ERROR = 'campaignEditorErrors/RESET_ERROR',
}
export const saveCampaignEditorErrors = (payload: Record<string, any>) => ({
    payload,
    type: CampaignEditorErrorsActions.SAVE_ERRORS,
})
export const resetCampaignEditorErrors = () => ({
    type: CampaignEditorErrorsActions.RESET_ERROR,
})
